<div class="speiseplan_div" *ngIf="menu_conf">
  <div class="speiseplan_links" [class.kleineAnsicht]="menu_conf.public.length < 5" [class.kleinerBildschirm]="kleinerBildschirm">
    <a class="float a" *ngFor="let tile of menu_conf.public" [routerLink]="['/' + tile.link]"
       [routerLinkActive]="['is-active']" (click)="sendSplanBez(tile.name)">
      <span id="spanID" *ngIf="tile.name">{{ tile.name }}</span>
    </a>
  </div>
</div>
